import { UserInterface } from '../types/user';

export const convertUserFromApi = (apiUser: any) => {
    const user: UserInterface = {
        name: apiUser.name,
        locations: apiUser.locations,
    };

    return user;
};
